import {Fragment} from "react";
import TagManager from "react-gtm-module";
import {createRoot} from "react-dom/client";
import {Apm} from "./apm";
import App from "./app";

const tagManagerArgs = {
  gtmId: "GTM-PWNN646",
};

TagManager.initialize(tagManagerArgs);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Fragment>
    <App />
    <Apm environment={import.meta.env.VITE_VERCEL_ENV} />
  </Fragment>
);
